import type { AuditLog, AuditLogList, GetAuditLogsQuery } from '@didaskill/domain/audit-logs/types';

import { HttpRepository } from '../httpRepository';

const BASE_AUDIT_LOGS_URI = '/api/v1/school/audit-logs';

export class AuditLogsRepository extends HttpRepository {
  /**
   * Fetches a paginated list of audit logs.
   * @param query Optional filters and pagination.
   * @returns Matching audit logs and the total hit count.
   */
  async getAuditLogs(query?: GetAuditLogsQuery): Promise<AuditLogList> {
    const { body } = await this.http.get(BASE_AUDIT_LOGS_URI).query(query);

    return body;
  }

  /**
   * Fetches a single audit log by id.
   * @param auditLogId Audit log identifier.
   * @returns The matching audit log.
   */
  async getAuditLog(auditLogId: string): Promise<AuditLog> {
    const { body } = await this.http.get(`${BASE_AUDIT_LOGS_URI}/${auditLogId}`);

    return body;
  }
}
